const PROXY = /^https:\/\/([^/]+\.)?(emergentagent\.net|cdninstagram\.com|fbcdn\.net|images\.unsplash\.com|images\.pexels\.com)\//;

export const opt = (url, w) => {
  if (!url) return url;
  if (url.includes('/api/images/')) return `${url.split('?')[0]}?w=${w}`;
  if (PROXY.test(url)) return `/api/img-proxy?w=${w}&u=${encodeURIComponent(url)}`;
  return url;
};

export const srcset = (url, widths = [400, 600, 800]) => (url && opt(url, 1) !== url ? widths.map((w) => `${opt(url, w)} ${w}w`).join(', ') : undefined);
